<script lang="ts">
export default {
    name: 'CrmLogo',
};
</script>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { getCrmLogoCandidates } from '@/utils/platform-logo';

const props = withDefaults(defineProps<{
    crm: string;
    name?: string;
    showTitle?: boolean;
}>(), {
    crm: 'default',
    showTitle: true,
});

const logoSrc = ref('');
const logoCandidates = ref<string[]>([]);
const title = computed(() => props.showTitle ? (props.name || props.crm) : undefined);

function setLogoSource(crm: string) {
    logoCandidates.value = getCrmLogoCandidates(crm);
    logoSrc.value = logoCandidates.value[0] ?? '';
}

function onImageError() {
    if (logoCandidates.value.length <= 1) {
        return;
    }

    logoCandidates.value = logoCandidates.value.slice(1);
    logoSrc.value = logoCandidates.value[0] ?? '';
}

watch(() => props.crm, (crm) => {
    setLogoSource(crm);
}, {
    immediate: true,
});
</script>

<template>
    <img
        class="shrink-0 aspect-[10/3] min-w-0 max-h-full object-contain"
        :src="logoSrc"
        :alt="name || crm"
        :title="title"
        @error="onImageError"
    >
</template>
